export default "__VITE_ASSET__y$t65Ddn__"